import { render, staticRenderFns } from "./ContactInfoAssignment.vue?vue&type=template&id=1d785854&scoped=true&"
import script from "./ContactInfoAssignment.vue?vue&type=script&lang=ts&"
export * from "./ContactInfoAssignment.vue?vue&type=script&lang=ts&"
import style0 from "./ContactInfoAssignment.vue?vue&type=style&index=0&id=1d785854&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d785854",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
